import { small } from '../../../constants/fonts';

export default {
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    position: 'relative',
    left: -15
  },
  chart: {
    top: 5,
    bottom: 15
  },
  baseStyle: {
    stroke: '#33a0d0',
    strokeWidth: 2,
    strokeLinejoin: 'round'
  },
  tooltipText: {
    fontSize: small
  },
  wrapper: {
    zIndex: 10,
    width: 180
  },
  legend: {
    fontSize: 14,
    top: 9
  }
};
